import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { updateForm } from '@redux/forms/actions';
import { selectFormUpdating } from '@redux/forms/reducers';
import FormWizard from './FormWizard';
import { useContentRefFromUrl } from '@hooks/useContentRefs';

export default ({
  match: {
    params: { id },
  },
  formTranslationKey,
  type,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [loading, form] = useContentRefFromUrl(id);

  const updating = useSelector(selectFormUpdating);

  const onCompleted = useCallback(
    formData => {
      dispatch(
        updateForm(
          formTranslationKey,
          form?.uuid,
          formData.details.name,
          formData.details.description,
          formData.details.language,
          formData.details.status === 'publish' ? true : false,
          formData.builder.schema
            ? {
                ...formData.builder.schema,
                schema: {
                  ...formData.builder.schema.schema,
                  ...(formData.content.json?.schema?.information
                    ? { information: formData.content.json.schema.information }
                    : {}),
                },
              }
            : formData.content.json,
          type,
          formData.content.json?.metadata?.fileName || formData.content.fileList[0]?.name,
          formData.details.audience,
        ),
      );
    },
    [formTranslationKey, dispatch, form, type],
  );

  return (
    <FormWizard
      title={t(`${formTranslationKey}:EditForm.title`)}
      exitMessage={t(`${formTranslationKey}:EditForm.exitConfirmation`)}
      loading={loading}
      submitting={updating}
      type={type}
      onCompleted={onCompleted}
      initialForm={form}
      initialFormData={form?.latestVersion}
      formTranslationKey={formTranslationKey}
      isEdit={true}
    />
  );
};
